"use strict";
export function tradeMeaningfullyDiffers(currentTrade, newTrade, slippage) {
  return currentTrade.tradeType !== newTrade.tradeType || !currentTrade.inputAmount.currency.equals(newTrade.inputAmount.currency) || !currentTrade.outputAmount.currency.equals(newTrade.outputAmount.currency) || newTrade.executionPrice.lessThan(currentTrade.worstExecutionPrice(slippage));
}
